export function findAndDeselect(nodes, val) {
    let found = null
    for (const node of nodes) {
        if (node.value === val) {
            node.selected = false
            if (!found) found = node
        }
        if (Array.isArray(node.items)) {
            const childFound = findAndDeselect(node.items, val)
            if (childFound && !found) found = childFound
        }
    }
    return found
}